import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { ErrorPage } from 'utils';

export const NotFoundPage: React.FC = () => <ErrorPage status="404" />;

export const NotFoundRoute: React.FC<RouteProps> = ({ path }) => (
  <Route path={path} component={NotFoundPage} />
);
